class Socket {
	constructor(depend) {
		let {methods, request, mitter, WS_API} = depend;
		this.methods = methods;
		this.request = request;
		this.mitter = mitter;
		this.WS_API = WS_API;

		//初始推送通道的保证
		this.initTask = null;
		//最后推送通道的活动时间（如果产生错误，会归0）
		//最后推送通道的活动时间（如果产生错误，会归0）
		this.lastAct = null;
		this.lastErr = null;
		//推送对象
		this.websock = null;
		this.heartBreath = 0;
		this.sessionID = null;

		this.joinGroups = {};
				
		
		this.reconnectAttempts = 0;
		this.maxReconnectAttempts = 5;
		this.reconnectDelay = 3000; // 3秒重连
		this.listeners = {}; // 存储事件监听
	}
  
	// 连接 WebSocket
	init() {
		if (this.initTask) return this.initTask;
		if (this.lastAct) return Promise.resolve();
		return this.initTask = new Promise((resolve, reject) => {
			this.methods.reTry(() => this.request({
				url: '/WebSocketKey',
				method: 'post',
			}), 3, 1000)
			.then(res => {
				let data = res.data.data;
				if (data && data.length>0) {
					let wsprotocol = window.location.protocol == 'https:' ? 'wss:' : 'ws:';
					let wshost = '';
					let wsurl = '';
					// 添加协议以便 URL 构造函数正确解析
					if(this.WS_API && !this.WS_API.includes('http')){
						wsurl = new URL(`http:${this.WS_API}`);
					}else{
						wsurl = new URL(`${this.WS_API}`);
					}
					wshost = wsurl.host;

					let url = `${wsprotocol}//${wshost}` + '/{"Action":"Web"}/' + data;
					this.websock = new WebSocket(url);

					this.websock.onopen = (e)=>{
						console.log("ws-open----:", e);
						if (this.heartBreath) {
							clearInterval(this.heartBreath);
							this.heartBreath = 0;
						}
						this.heartBreath = setInterval(() => { // 如果上一次推送时间大于15秒就发送
							if ((new Date().getTime() - this.lastAct) > 3000) {
								this.send({data: ''});
							}
						}, 5000);
						if(this.lastErr){
							Object.keys(this.joinGroups).forEach(act=>{
								var sendJoins = Object.keys(this.joinGroups[act]);
								console.log("重发join",act, sendJoins);
								if (act=='FBScore' || act=='BtBScore' || act=='TMatchScore') {
									for (let index = 0; index < sendJoins.length/100; index++) {
										this.send({
											data: JSON.stringify({
												command: "JoinGroup",
												action: act,
												ids: sendJoins.slice(index*100, index*100+100)
											})
										});
									}
								}else{
									this.send({
										data: JSON.stringify({
											command: "JoinGroup",
											action: act,
											ids: sendJoins
										})
									});
								}
							})
							this.lastErr = null;
						}
					};
					this.websock.onmessage = (e)=>{
						// console.log("ws-message----:", e);
						if (!e.data) return;
						const data = JSON.parse(e.data);
						//数据接收
						if (data.sessionid && data.sessionid != '') {
							this.sessionID = data.sessionid;
							resolve();
						}
						// 足球比分
						var action = data[0] && data[0].action;
						// console.log('action', data);
						if (action) {
							switch (action) {
								case "FBScore":
								case "BtBScore":
								case "TMatchScore":
								case "FBMatchTextLive":
								case "BBMatchTextLive":
								case "FBMatchEvent":
								case "FBMatchLineUp":
								case "FBMatchStat":
								case "BBMatchStat":
								case "BBPlayingTime":
								case "ChatRoom":
								case "FbUnstructuredData":
								case "BtbUnstructuredData":
								case "MatchChange":
								case "ChatRoomLike":
									this.lastAct = new Date().getTime();
									if (data[0].data.length) {
										this.mitter.emit(action, data[0].data[0]);
									}
									break;
							}
						}
					};
					this.websock.onerror = (e)=>{
						console.log("ws-error----:", e);
						this.lastAct = null;
						clearInterval(this.heartBreath);
						this.heartBreath = 0;
						this.lastErr = new Date().getTime();
						if (!this.websock) {
							this.init();
						} else {
							this.websock == null;
						}
					};
					this.websock.onclose = (e)=>{
						console.log("ws-close----:", e);
						this.lastAct = null;
						clearInterval(this.heartBreath);
						this.heartBreath = 0;
						this.lastErr = new Date().getTime();
						if (this.websock) {
							this.websock.close();
							this.websock == null;
						}
					};
				}
			}).catch(err=>{
				console.log(err);
				reject(err);
			})
		})

	}
  
  
	// 发送消息
	send(data) {
		// console.log('发送消息-------------------',data);
		this.init().then(() => {
			if(!this.websock) return;
			this.websock.send(data.data);
			this.lastAct = new Date().getTime();
		})
	}
  
	// 监听事件
	on(type, callback) {
	  if (!this.listeners[type]) {
		this.listeners[type] = [];
	  }
	  this.listeners[type].push(callback);
	}
  
	// 关闭连接
	close() {
	  if (this.websock) {
		this.websock.close();
		//初始推送通道的保证
		this.initTask = null;
		//最后推送通道的活动时间（如果产生错误，会归0）
		//最后推送通道的活动时间（如果产生错误，会归0）
		this.lastAct= null;
		this.lastErr= null;
		//推送对象
		this.websock= null;
		this.heartBreath= 0;
		this.sessionID= null;
		//{"act1":{id1:times1, id2,times2}}
		this.joinGroups= {};
	  }
	}
	join(act, datas) {
		let readyConfig = {
			timer: null,
			count: 0,
		};
		let socketGetReady =()=>{
			if(this.websock && this.sessionID){
				if (!act || !datas || !datas.length) return;
				
				if (!this.joinGroups[act]) {
					this.joinGroups[act] = {};
				}
				var sendJoins = [];
				datas.forEach(data => {
					if (!this.joinGroups[act][data]) {
						this.joinGroups[act][data] = 1; 
						sendJoins.push(data);
					} else {
						this.joinGroups[act][data]++;
					}
				})
				if (sendJoins.length) {
					if (act=='FBScore' || act=='BtBScore' || act=='TMatchScore') {
						for (let index = 0; index < sendJoins.length/100; index++) {
							this.send({
								data: JSON.stringify({
									command: "JoinGroup",
									action: act,
									ids: sendJoins.slice(index*100, index*100+100)
								})
							});
						}
					}else{
						this.send({
							data: JSON.stringify({
								command: "JoinGroup",
								action: act,
								ids: sendJoins
							})
						});
					}
				}
			}
			if(!this.websock || !this.sessionID){		
				if(readyConfig.count>20){
					clearTimeout(readyConfig.timer);
					readyConfig.timer = null;
					return;
				}
				readyConfig.timer = setTimeout(socketGetReady,200);
				readyConfig.count +=1;
			}
		}
		socketGetReady();
	};

	quit(act, datas) {
		let readyConfig = {
			timer: null,
			count: 0,
		};
		let socketGetReady =()=>{
			if(this.websock && this.sessionID){
				if (!act || !datas || !datas.length) return;
				if (!this.joinGroups[act]) {
					this.joinGroups[act] = {};
				}
				var sendQuits = [];
				datas.forEach(data => {
					if (this.joinGroups[act][data]) {
						this.joinGroups[act][data]--; // 关闭比赛列表页（join两次，this.joinGroups[act][data]>0) 需把所有的比分推送都关闭
						if (!this.joinGroups[act][data] || this.joinGroups[act][data]) {
							sendQuits.push(data);
							this.joinGroups[act][data] = 0;
						}
					}
				})
				if (sendQuits.length) {
					if (act=='FBScore' || act=='BtBScore' || act=='TMatchScore') {
						for (let index = 0; index < sendQuits.length/100; index++) {
							this.send({
								data: JSON.stringify({
									command: "QuitGroup",
									action: act,
									ids: sendQuits.slice(index*100, index*100+100)
								})
							});
						}
					}else{
						this.send({
							data: JSON.stringify({
								command: "QuitGroup",
								action: act,
								ids: sendQuits
							})
						});
					}		
				}
			}
			if(!this.websock || !this.sessionID){		
				if(readyConfig.count>20){
					clearTimeout(readyConfig.timer);
					readyConfig.timer = null;
					return;
				}
				readyConfig.timer = setTimeout(socketGetReady,200);
				readyConfig.count +=1;
			}
		}
		socketGetReady();
	};
	joinRoom(roomID, chatRoomType) {
		return this.init().then(() => {
			return this.methods.reTry(() => this.request({
				url: '/JoinChatRoom',
				data: {
					chatRoomId: roomID,
					chatRoomType: chatRoomType,
					sessionId: this.sessionID,
				},
				method: 'post',
			}), 3, 1000).then((res) => {
				if (res.data.code == 200) {
					let msg = res.data.msg;
					if (msg && msg.length>1) {
						let objdata = {
							chatRoomId: roomID,
							chatRoomType: chatRoomType,
							sessionID: this.sessionID,
							noticeText: msg,
						}
						console.log('WebSocketjoinRoom发送公告',objdata);
						this.mitter.emit('joinRoom', objdata);
					}
					// console.log("加入房间成功,");
				}
			});
		});
	};
	quitRoom(roomID) {
		if(!this.websock) return;
		this.send({
			data: JSON.stringify({
				command: "QuitGroup",
				action: 'ChatRoom',
				ids: [roomID]
			})
		});
	};

  }
  
  export default Socket;